module.exports = __webpack_public_path__ + "04_mid_yellow.04e7c9ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/04_mid_yellow.png
// module id = dHWI
// module chunks = 0